import config from "config/index";

export function getVehicleMarketplaceListingUrl(city: string, listingId: number) {
    return `${config.vehicleMarketplaceUrl}/city/${city}/listing/${listingId}`;
}
